<template>
  <div>
    <form-model :title="title" width="700" ref="formModel">
      <Button slot="btn" type="primary" @click="addUpdate">提交表单</Button>
    </form-model>
    <createdFlow ref="createdFlow"></createdFlow>
  </div>
</template>
<script>
import fields from "./fields";
import createdFlow from "./createdFlow.vue";
export default {
  components: { createdFlow },
  data() {
    return {
      openForm: false,
      isAdd: true,
      forms: [],
      ruleValidate: {},
      item: {
        groupName: "",
        groupId: "",
        pileNo: ["全线快车道"],
        dept: "珠海市公路事务中心",
        time: Date.now(),
        address: "横琴二桥",
        workerLeader: "",
        dispatcher: "",
        applyId: "",
      },
      title: "",
      flowId: "",
      selects: {
        pileNoList: ["全线快车道", "全线慢车道", "全线应急车道"],
        itemList: [
          "日常保洁养护",
          "日常巡查",
          "夜巡视",
          "清洗横琴二桥全线伸缩缝",
          "清洗横琴二桥全线泄水孔、排水沟",
          "清理疏通横琴二桥易积水点",
          "清洗横琴二桥全线标志牌、防撞墙、波形护栏等交安设施",
          "对横琴二桥全线绿化植物浇水",
          "对横琴二桥全线绿化植物除草、修剪、杀虫",
          "对横琴二桥全线绿化植物施肥",
        ],
      },
    };
  },
  methods: {
    reach(v) {
      this.forms = fields[v.field];
      this.title = v.name;
      this.serverUrl = v.serverUrl;
      this.flowId = v.flowId;
      this.formId = v.id;
      this.getUser();
      this.getApply();
      //https://cloud.ly-gps.com/cloud-rmm-server-dpm/apply
    },
    addUpdate(name) {
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }
      this.item = a;
      this.axios({
        method: "post",
        url: this.serverUrl + "/add",
        data: this.item,
      }).then((res) => {
        if (res) {
          this.$refs.formModel.close();
          var data = res.data.data;
          var obj = {
            flowId: this.flowId,
            id: data.id,
            no: data.no,
            groupId: data.groupId,
            formId: this.formId,
          };
          this.$refs.createdFlow.reach(obj);
        }
      });
    },
    resetForm() {
      this.$refs["item"].resetFields();
    },

    getUser() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: "/account/getUserItem",
        data: {},
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var data = res.data.data;
        this.item.dispatcher = this.utils.text(data.name, "");
        this.$refs.formModel.reach(this.forms, this.item);
      });
    },
    //获取高危作业申请单
    getApply() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.dpm + "/apply/list",
        data: {
          startTime: Date.now() - 86400000 * 15,
          endTime: Date.now(),
          pageNumber: 1,
          pageSize: 50,
        },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var data = res.data.data.dataList;
        for (let i = 0; i < this.forms.length; i++) {
          if (this.forms[i].key == "applyId") {
            console.log(data);
            this.forms[i].selectItems = [];
            for (let j = 0; j < data.length; j++) {
              var obj = {
                name: data[j].no,
                id: data[j].id,
              };
              console.log(this.forms[i].key);
              this.forms[i].selectItems.push(obj);
            }
          }
        }
      });
    },
  },
  mounted() {},
};
</script>


// WEBPACK FOOTER //
// src/components/yhgl/forms/xiaoxiuzuoye.vue